export const formatCurrency = (v) =>
  new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(v ?? 0);

export const formatNumber = (v, decimals = 1) =>
  new Intl.NumberFormat("nl-NL", { maximumFractionDigits: decimals, minimumFractionDigits: 0 }).format(v ?? 0);

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("nl-NL", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("nl-NL", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const formatRelative = (iso) => {
  if (!iso) return "—";
  const diff = (new Date(iso).getTime() - Date.now()) / 1000;
  const abs = Math.abs(diff);
  const sign = diff < 0 ? "" : "over ";
  const past = diff < 0 ? " geleden" : "";
  if (abs < 60) return "zojuist";
  if (abs < 3600) return `${sign}${Math.round(abs / 60)} min${past}`;
  if (abs < 86400) return `${sign}${Math.round(abs / 3600)} uur${past}`;
  const days = Math.round(abs / 86400);
  return `${sign}${days} ${days === 1 ? "dag" : "dagen"}${past}`;
};
